import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpUtilService } from "../http-util.service";

@Injectable({
  providedIn: "root",
})
export class UnpaidInvoicesReportService {
  constructor(private http: HttpUtilService) {}

  UnpaidInvoicesReport(
    FromDate: string,
    ToDate: string,
  ): Observable<any> {
    return this.http.post(
      "SalesReportService.asmx/UnpaidInvoicesReport",
      {
        model: {
          FromDate,
          ToDate,
        },
      },
    );
  }
}
